import { AppBar, AppBarProps, styled } from '@mui/material';
import { Palette } from 'Palette';

interface StyledAppBarProps extends AppBarProps {
  paddingX?: number | string;
  tone?: keyof typeof Palette;
}

export const StyledAppBar = styled(AppBar, {
  shouldForwardProp: (prop: string) => !['paddingX', 'tone'].includes(prop),
})<StyledAppBarProps>(({ theme, paddingX, tone = 'default', className }) => ({
  backgroundColor: Palette[tone].background,
  paddingRight: paddingX ?? theme.spacing(2),
  height: 80,
  minHeight: 80,
  overflow: 'visible',
  zIndex: theme.zIndex.appBar + 1,
  '& .MuiToolbar-root': {
    minHeight: '80px', // ✅ fully override MUI's default 64px
    height: '80px',
    boxSizing: 'border-box',
  },
  className: `react-StyledAppBar ${className || ''}`.trim(),
}));
